import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import { computed, ref } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const key = computed(() => {
  return route.name
})

dayjs.locale('zh-cn')
const locale = ref(zhCN)

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { locale: locale.value }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(AppHeader),
          _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_spin, { spinning: false }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_RouterView, { key: key.value }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["locale"]))
}
}

})